import { ResultData, UserEntity } from '@/typings';
import { getPage } from '@/utils/util';
import { request } from '@umijs/max';


export interface LoginResult {
    token: string;
}
export async function login(
    data: {
        userName: string;
        password: string;
    },
) {
    return request<LoginResult>('/api/token', {
        method: 'POST',
        data,
    });
}

export async function queryCurrentUser() {
    return request<UserEntity>('/api/user/current', {
        method: 'GET',
        data: {},
    });
}

export async function modifyPassword() {
    return request<UserEntity>('/api/user/password', {
        method: 'PUT',
        data: {},
    });
}

export async function resetPassword(userId: number) {
    return request<UserEntity>('/api/user/password/reset/' + userId, {
        method: 'PUT',
        data: {},
    });
}

export async function queryUsers(pars: any) {
    const res = await getPage('/api/user/list', pars);
    return res;
}

export async function addUser(data: UserEntity) {
    return request('/api/user', {
        method: 'POST',
        data
    });
}
export async function modifyUser(data: UserEntity) {
    return request('/api/user', {
        method: 'PUT',
        data
    });
}

export async function deleteUser(id: number) {
    return request('/api/user/' + id, {
        method: 'DELETE',
    });
}

export async function getUser(id: number) {
    return request<UserEntity>('/api/user/' + id, {
        method: 'GET',
    });
}